import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const HomeInspector = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my home inspector business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps home inspector businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for home inspector businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most home inspector businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my home inspector business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like home inspector. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Home Inspector - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Home Inspector CRM", url: "/industries/home-inspector" }
  ];

  const industryData = {
    name: 'Home Inspector',
    title: 'Stop Missing Realtor Referrals & Book More Inspections',
    subtitle: 'Capture urgent inspection requests, automate report delivery, and build strong realtor partnerships',
    icon: '🏠',
    challenges: [
      'Missing calls from realtors means lost business',
      'Hard to stand out to real estate agents',
      'Manual report delivery takes too long',
      'Difficult to get realtor referrals',
      'Seasonal fluctuations in bookings'
    ],
    solutions: [
      'Instant response to realtor inquiries',
      'Automated report delivery system',
      'Realtor partnership nurture campaigns',
      'Online scheduling for immediate bookings',
      'Seasonal marketing automation'
    ],
    features: [
      'Realtor CRM and referral tracking',
      'Online booking calendar',
      'Automated report delivery',
      'Follow-up sequences for agents',
      'Seasonal marketing campaigns',
      'Review automation',
      'Before/after documentation',
      'Mobile inspection app'
    ],
    results: [
      '3x more realtor partnerships',
      '85% faster report turnaround',
      'Book 40% more inspections',
      '£4.5K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Home Inspector UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for home inspector businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for home inspector UK, home inspector business software, home inspector customer management, home inspector lead generation UK"
        url="/industries/home-inspector"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default HomeInspector;